import React from 'react';
import { useLoading } from '../Utils/LoadingContext';
import './LoadingSpinner.css';
const LoadingSpinner = () => {
    const { loading } = useLoading();

    if (!loading) return null;

    return (
        <div className="loading-overlay">
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
        </div>
    );
};

export default LoadingSpinner;
